import { TruncatedText as NDSTruncatedText } from "@nulogy/components";
import { getTooltipProps } from "components/pages/schedule/workOrderCards/helpers/TruncatedTextTooltipHelper";
import React from "react";
import styled from "styled-components";

const TruncatedText = styled(NDSTruncatedText)(({ grabbable }) => ({
  cursor: grabbable ? "grab" : "default",
}));

export default function DraggableCardTruncatedText({ children, grabbable = true, ...props }) {
  return (
    <TruncatedText
      fontSize="smaller"
      fullWidth
      grabbable={grabbable}
      lineHeight="smallerText"
      tooltipProps={getTooltipProps(children)}
      {...props}
    >
      {children}
    </TruncatedText>
  );
}
